import { Breadcrumb, HeaderToolbar, Tabs } from "@xola/ui-kit";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { ColumnLayout } from "../../components/Layout/ColumnLayout";
import { XolaBotPluginList } from "../../components/XolaBot/XolaBotPluginList/XolaBotPluginList";
import { EditXolaBotPreferenceForm } from "../../components/XolaBot/XolaBotSettingsEditor/EditXolaBotPreferenceForm";
import { Page } from "../Page";

export const XolaBotPage = () => {
    const history = useHistory();
    const { section } = useParams<{ section?: string }>();

    const initialSection = section ?? tabIds[0].id;
    const initialActiveIndex = tabIds.findIndex((tab) => tab.id === section ?? initialSection);

    const [activeTabIndex, setActiveTabIndex] = useState(initialActiveIndex === -1 ? 0 : initialActiveIndex);
    const activeTab = ["Apps", "Settings"][activeTabIndex];

    useEffect(() => {
        if (initialActiveIndex >= 0 && activeTabIndex !== initialActiveIndex) {
            setActiveTabIndex(initialActiveIndex);
        }
    }, [initialActiveIndex, activeTabIndex]);

    const changeTab = (tabIndex: number) => {
        history.push(`/marketing/xolabot/${tabIds[tabIndex].id}`);
    };

    return (
        <Page title={activeTab}>
            <ColumnLayout>
                <HeaderToolbar>
                    <HeaderToolbar.Breadcrumb>
                        <Breadcrumb.Item>Marketing</Breadcrumb.Item>
                        <Breadcrumb.Item>XolaBot</Breadcrumb.Item>
                        <Breadcrumb.Item>{activeTab}</Breadcrumb.Item>
                    </HeaderToolbar.Breadcrumb>
                </HeaderToolbar>

                <ColumnLayout.Fill>
                    <Tabs value={activeTabIndex} onChange={changeTab}>
                        <Tabs.Tab isActive>Apps</Tabs.Tab>

                        <Tabs.Panel isActive>
                            <XolaBotPluginList />
                        </Tabs.Panel>

                        <Tabs.Tab>Settings</Tabs.Tab>

                        <Tabs.Panel>
                            <EditXolaBotPreferenceForm />
                        </Tabs.Panel>
                    </Tabs>
                </ColumnLayout.Fill>
            </ColumnLayout>
        </Page>
    );
};

const tabIds = [{ id: "apps" }, { id: "settings" }];
